import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <footer className='footer'>
      <h3>Busque pela sua saúde</h3>
      <p>Gym Map&copy; 2022</p>
    </footer>
  )
}

export default Footer